import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommSendLoadOptionsList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceMCSendLoadOptions: DataSource;
    tableSendLoadOptions: Table;
}
